export default __webpack_public_path__ + "static/media/red@3x.44f07a45.png";